module Meevo.Plugins.AppointmentBook {
    class ServiceAddOnsController {
        public serviceAddOns: any[];
        public serviceAddOnsPreviouslySold: any[];
        public serviceAddOnsNotPreviouslySold: any[];
        selectedServiceAddOns: any[];
        serviceAlerts: any[] = [];
        isMobileDeviceMode: boolean;
        hasRequiredAddOns: boolean;
        numberRequiredAddOns: number;
        labelRequiredAddOns: string;
        isValid: boolean = true;

        static $inject = [
            'meevo.components.common.DataService',
            'appointmentBookModalService',
            'meevo.components.modal.ModalService',
            '$translate',
            'restServer',
            'currentServiceAddOns',
            'finalState',
            'transitionState',
            'serviceId',
            'employeeId',
            'isReadOnly',
            'isFromWalkIn',
            'clientId',
            'equipmentValidator',
            'yieldManagementDateTime',
            'applyProductUsage',
            'appointmentServiceId',
            '$q',
        ];

        constructor(
            private dataService,
            private modal,
            private $modalService: Meevo.Components.Modal.ModalService,
            private $translate: angular.translate.ITranslateService,
            private restServer,
            private currentServiceAddOns,
            private finalState,
            private transitionState,
            private serviceId,
            private employeeId,
            public isReadOnly, // used in HTML
            private isFromWalkIn: boolean = false,
            private clientId,
            private equipmentValidator,
            private yieldManagementDateTime: any = undefined,
            private applyProductUsage,
            private appointmentServiceId,
            private $q
        ) {
            this.selectedServiceAddOns = [];

            this.loadData().then(() => {
                if (this.currentServiceAddOns && this.currentServiceAddOns.length > 0) {
                    _(this.currentServiceAddOns).each((item) => {
                        const selectedAddon = _(this.serviceAddOns).find(addon => addon.serviceId == item.addOnServiceId);
                        if (selectedAddon) {
                            this.changeAddOnSelection(selectedAddon, true);
                        }
                    });
                } else {
                    this.updateValidation();
                }
            });

            this.serviceAlerts.push(<PassiveAlert>{
                alertMessage: this.$translate.instant("MESSAGE_EMPLOYEE_DOES_NOT_PERFORM_SERVICE"),
                alertPriorityLevel: Meevo.Model.AlertPriorityLevelEnum.High
            });

            this.isMobileDeviceMode = device.mobile();
        }

        onPageLoad(serviceAddOnsAll: any[]) {
            for (let index = 0, len = serviceAddOnsAll.length; index < len; index++) {
                let item = serviceAddOnsAll[index];
                item.isSelected = !!_.findWhere(this.currentServiceAddOns, { addOnServiceId: item.serviceId });
                if (this.isFromWalkIn) { // Force true for walk-in so alerts aren't visible
                    item.employeePerformsService = true;
                }
            }
        }

        splitServiceAddOnsList(serviceAddOnsAll: any[]) {
            this.serviceAddOnsPreviouslySold = _.where(serviceAddOnsAll, { hasPriorVisitAtLocation: true });
            this.serviceAddOnsNotPreviouslySold = _.where(serviceAddOnsAll, { hasPriorVisitAtLocation: false });
        }

        loadData() {
            const deferred = this.$q.defer();
            let serviceAddOnRequest = {
                pageNumber: 0,
                itemsPerPage: 10000,
                sortDirection: Model.SortDirection.Ascending,
                serviceId: this.serviceId,
                employeeId: this.employeeId,
                finalState: this.finalState,
                transitionState: this.transitionState,
                clientId: this.clientId
            };

            this.dataService.getListPaged('AppointmentService/ServiceAddOnsTemplate', serviceAddOnRequest).then(response => {
                this.numberRequiredAddOns = (response.addOnGroups).reduce((sum, addOnGroup) => sum + addOnGroup.numberAddOnsRequired, 0);

                this.hasRequiredAddOns = this.numberRequiredAddOns > 0;

                if (this.hasRequiredAddOns) {
                    this.labelRequiredAddOns = this.$translate.instant("LABEL_SERVICE_REQUIRES_X_ADDONS", {
                        numberRequiredAddOns: this.numberRequiredAddOns
                    });
                }

                this.serviceAddOns = _.chain(response.addOnServices)
                    .map(addOn => ({
                        serviceId: addOn.serviceId,
                        displayName: addOn.displayName,
                        shortcut: addOn.shortcut,
                        description: addOn.description,
                        catalog: addOn.catalog,
                        employeePerformsService: addOn.employeePerformsService,
                        hasServiceFee: addOn.hasServiceFee,
                        price: addOn.price,
                        extendedByStepMinutes: addOn.extendedByStepMinutes,
                        extendedByStepId: addOn.extendedByStepId,
                        isRequired: addOn.isRequired,
                    }))
                    .uniq(addOn => addOn.serviceId)
                    .value();

                const addOnPriceRequests = this.serviceAddOns.map(addOn => ({
                    serviceId: addOn.serviceId,
                    employeeId: this.employeeId,
                    clientId: this.clientId,
                    startDateTime: this.yieldManagementDateTime,
                    appointmentServiceId: this.appointmentServiceId
                }));

                return this.restServer.getRegisterPriceList(addOnPriceRequests, this.applyProductUsage).then(response => {
                    const addOnPrices: any[] = response.data.services;
                    this.serviceAddOns.forEach(addOn => {
                        addOn.price = addOnPrices.find(addOnPrice => addOnPrice.priceRequest.serviceId === addOn.serviceId).finalPriceCharge;
                    });

                    if (this.clientId) {
                        const serviceIds = _(this.serviceAddOns).pluck('serviceId');
                        this.getServiceWithPriorVisitList(serviceIds);
                    } else {
                        this.serviceAddOns.forEach(addOn => {
                            addOn.hasPriorVisitAtLocation = false;
                        });
                        this.onPageLoad(this.serviceAddOns);
                        this.splitServiceAddOnsList(this.serviceAddOns);
                    }
                    
                    deferred.resolve();
                });
            });

            return deferred.promise;
        }

        private getServiceWithPriorVisitList(serviceIds) {
            const url = `api/Client/${this.clientId}/ServiceWithPriorVisit/List`;
            const serviceWithPriorVisitUnpagedListRequest = {
                clientId: this.clientId,
                serviceIds: serviceIds
            };

            return this.dataService.customMethodData(url, 'POST', serviceWithPriorVisitUnpagedListRequest).then(response => {
                const serviceWithPriorVisitAtLocationList = response.data;
                this.serviceAddOns.forEach((addOn: any) => {
                    addOn.hasPriorVisitAtLocation = (serviceWithPriorVisitAtLocationList.length > 0 &&
                        !!_.findWhere(serviceWithPriorVisitAtLocationList, { serviceId: addOn.serviceId }));
                });

                this.onPageLoad(this.serviceAddOns);
                this.splitServiceAddOnsList(this.serviceAddOns);
            });
        }

        changeAddOnSelection = (addOnService, isSelected) => {
            if (isSelected) {
                if (_(this.selectedServiceAddOns).any(addOn => addOn.addOnServiceId == addOnService.serviceId)) {
                    return;
                }
                this.selectedServiceAddOns.push({
                    addOnServiceId: addOnService.serviceId,
                    serviceDisplayName: addOnService.displayName,
                    serviceShortcut: addOnService.shortcut,
                    price: addOnService.price,
                    extendedByStepId: addOnService.extendedByStepId,
                    extendedByStepMinutes: addOnService.extendedByStepMinutes,
                    isRequired: addOnService.isRequired,
                });
            } else {
                const removeIndex = _.findIndex(this.selectedServiceAddOns, (addon: any) => addon.addOnServiceId == addOnService.serviceId);
                this.selectedServiceAddOns.splice(removeIndex, 1);
            }
            this.updateValidation();
        }

        private updateValidation() {
            if (!this.hasRequiredAddOns) {
                this.isValid = true;
                return;
            }

            const selectedRequiredAddons = _(this.selectedServiceAddOns).filter(addon => addon.isRequired).length;
            this.isValid = selectedRequiredAddons >= this.numberRequiredAddOns;
        }

        saveSelectAddOns() {
            if (!this.isValid) {
                $('#service-addon-modal').hide();
                this.$modalService.alert(this.labelRequiredAddOns, Components.Modal.ModalTranslationModes.DoNotTranslate, true).finally(() => {
                    $('#service-addon-modal').show();
                });
                return;
            }

            const continueExecution = () => {
                this.modal.hideModal({ action: 'save', data: this.selectedServiceAddOns });
            };

            if (this.equipmentValidator) {
                this.equipmentValidator.checkSeviceAddOnEquipment(this.selectedServiceAddOns).then((response) => {
                    if (response) {
                        continueExecution();
                    }
                });
            }
            else {
                continueExecution();
            }
        }

        closeSelectAddOns() {
            this.modal.hideModal({ action: 'close', data: this.hasRequiredAddOns });
        }

        cancelSelectAddOns() {
            this.modal.hideModal({ action: 'cancel', data: this.hasRequiredAddOns });
        }
    }

    angular.module("ApptBookApp")
        .controller("meevo.plugins.appointmentBook.ServiceAddOnsController", ServiceAddOnsController);
}
